<template>
  <div>
    <a style="color: black" @click="back">
      <a-icon type="left" class="hover-font-active" />
      <span style="font-size: 16px; margin-left: 10px">费用申请</span>
    </a>

    <a-form-model
      v-if="is != 'check'"
      style="margin-top: 20px; margin-left: 27px"
      labelAlign="left"
      ref="ruleForm"
      :model="queryParam"
      :rules="rules"
    >
      <a-form-model-item
        :colon="false"
        :labelCol="{ lg: { span: 2 } }"
        :wrapperCol="{ lg: { span: 10 } }"
        label="学期"
        prop="termId"
      >
        <a-select
          v-model="queryParam.termId"
          class="form-cell"
          placeholder="请选择学期"
        >
          <a-select-option
            v-for="item in termList"
            :key="item.id"
            :value="item.id"
            >{{ item.termName }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item
        :colon="false"
        :labelCol="{ lg: { span: 2 } }"
        :wrapperCol="{ lg: { span: 10 } }"
        label="费用类型"
        prop="expenseType"
      >
        <a-select placeholder="请选择" v-model="queryParam.expenseType">
          <a-select-option
            v-for="item in expenseType"
            :key="item.id"
            :value="item.id"
            >{{ item.expenseName }}</a-select-option
          >
        </a-select>
      </a-form-model-item>

      <a-form-model-item
        :colon="false"
        :labelCol="{ lg: { span: 2 } }"
        :wrapperCol="{ lg: { span: 10 } }"
        label="金额"
        prop="amount"
      >
        <a-input v-model="queryParam.amount" placeholder="请输入"></a-input>
      </a-form-model-item>

      <a-form-model-item
        :colon="false"
        :labelCol="{ lg: { span: 2 } }"
        :wrapperCol="{ lg: { span: 10 } }"
        label="费用备注"
        prop="remark"
      >
        <a-textarea
          v-model="queryParam.remark"
          placeholder="请输入"
          :max-length="512"
          :auto-size="{ minRows: 12, maxRows: 15 }"
        />
      </a-form-model-item>
      <a-form-model-item
        :colon="false"
        :labelCol="{ lg: { span: 2 } }"
        :wrapperCol="{ lg: { span: 10 } }"
        label="附件"
        prop="addAttachmentId"
      >
        <div>
          <a-upload
            name="file"
            :multiple="true"
            :action="action"
            :defaultFileList="defaultFileList"
            :headers="requestHeader.createHeaders(uploadFileData)"
            :data="uploadFileData"
            :remove="handleRemove"
            @change="upload"
            @preview="preview"
          >
            <a>上传</a>
          </a-upload>
        </div>
      </a-form-model-item>
    </a-form-model>

    <div class="detail" v-if="is == 'check'">
      <div class="blod">审核记录</div>
      <a-table
        :dataSource="detail.processDtoList"
        :columns="columns"
        class="tableWidth"
        :pagination="false"
        :locale="locale"
      >
        <span slot="operationDesc" slot-scope="text, record">
          <template>
            <a :title="record.operationDesc" style="color: #000000a6">{{
              record.operationDesc
            }}</a>
          </template>
        </span>
      </a-table>
      <div class="blod">费用信息</div>
      <a-form
        labelAlign="right"
        :label-col="{ span: 2 }"
        :wrapper-col="{ span: 14 }"
      >
        <a-form-item label="审核单号">
          {{ detail.id }}
        </a-form-item>
        <a-form-item label="学期">
          {{ detail.termText }}
        </a-form-item>
        <a-form-item label="学校ID">
          {{ detail.schoolId }}
        </a-form-item>
        <a-form-item label="学校">
          {{ detail.schoolName }}
        </a-form-item>
        <a-form-item label="费用类型">
          {{ detail.expenseTypeText }}
        </a-form-item>
        <a-form-item label="金额">
          {{ detail.amount ? detail.amount : 0 }}
        </a-form-item>
        <a-form-item label="费用备注">
          <span style="line-height: 20px; white-space: pre-line">{{
            detail.remark
          }}</span>
        </a-form-item>
        <a-form-item label="附件">
          <a
            style="display: block"
            @click="download(item.comAttachmentFileFileUrl)"
            v-for="(item, index) in detail.enclosure"
            :key="index"
            >{{ item.fileName }}</a
          >
        </a-form-item>
        <a-form-item label="状态">
          {{ detail.statusText }}
        </a-form-item>
        <a-form-item v-if="this.detail.status == 2" label="打款凭证">
          <a
            style="display: block"
            target="_blank"
            v-for="(item, index) in detail.paymentVoucher"
            :key="index"
            @click="download(item.comAttachmentFileFileUrl)"
            >{{ item.fileName }}</a
          >
        </a-form-item>
      </a-form>
    </div>

    <div class="btn">
      <a-button
        class="mr15 w90"
        type="primary"
        v-if="this.is == 'add' || this.is == 'update'"
        @click="submitApplication('ruleForm')"
        >提交申请</a-button
      >
      <a-button
        class="mr15 w90"
        type="primary"
        v-if="this.detail.status == -1"
        @click="batchSubmit('ruleForm')"
        >提交申请</a-button
      >
      <a-button
        class="mr15 w90"
        type="primary"
        v-if="this.is == 'add' || this.is == 'update'"
        @click="save('ruleForm')"
        >保存</a-button
      >
      <a-button
        class="mr15 w90"
        type="primary"
        v-if="this.is == 'add' || this.is == 'update'"
        @click="back"
        >取消</a-button
      >
      <a-button
        class="mr15 w90"
        type="primary"
        v-if="this.detail.status == -1"
        @click="resubmit"
        >修改</a-button
      >
      <a-button
        class="mr15 w90"
        type="primary"
        v-if="this.detail.status == -1"
        @click="batchDelete"
        >删除</a-button
      >
      <a-button
        class="mr15 w90"
        type="primary"
        v-if="this.detail.status == 3 && this.is == 'check'"
        @click="resubmit"
        >重新提交</a-button
      >
    </div>

    <a-modal
      :width="700"
      :visible="visible"
      :maskClosable="false"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <div style="margin-top: 20px">
        <p style="font-size: 16px">操作说明：</p>
        <a-textarea
          v-model="operationDesc"
          style="margin-top: 15px"
          :max-length="480"
          :auto-size="{ minRows: 10, maxRows: 15 }"
        ></a-textarea>
      </div>
    </a-modal>
  </div>
</template>

<script>
import requestHeader from '../../utils/requestHeader'
import finOrder from '../../api/finOrder'
import globalConfig from '../../config/globle.config'
const columns = [
  {
    title: '操作时间',
    dataIndex: 'date',
    width: 100,
  },
  {
    title: '操作人',
    dataIndex: 'userName',
    width: 100,
  },
  {
    title: '操作',
    dataIndex: 'operation',
    width: 100,
  },
  {
    title: '操作说明',
    dataIndex: 'operationDesc',
    scopedSlots: { customRender: 'operationDesc' },
    width: 100,
    ellipsis: true,
  },
]
export default {
  data() {
    return {
      globalConfig,
      requestHeader,
      location,
      columns,
      loggingList: [{ aa: 1, bb: 2, cc: 3, dd: 4 }],
      form: {},
      rules: {
        termId: [
          {
            required: true,
            message: '请选择',
            trigger: 'blur',
          },
        ],
        expenseType: [
          {
            required: true,
            message: '请选择',
            trigger: 'blur',
          },
        ],
        amount: [
          {
            required: true,
            message: '请输入',
            trigger: 'blur',
          },
          {
            // pattern: /^\d+(.\d{1,2})?$/,
            pattern: /^\d+(\.\d{0,2})?$/,
            message: '仅限输入数字,金额最小单位为分',
          },
        ],
        remark: [
          {
            required: true,
            message: '请输入',
            trigger: 'blur',
          },
        ],
        // addAttachmentId: [
        //   {
        //     required: true,
        //     message: '请上传',
        //     trigger: 'change',
        //   },
        // ],
      },
      visible: false, //弹框显示
      confirmLoading: false, //弹框确认按钮loading
      termList: [], //学期列表
      expenseType: [], //费勇类型列表
      is: '', //页面属性
      expenseId: '', //查看详情id
      queryParam: {}, //新增修改内容
      detail: {}, //详情内容
      operationDesc: '', //操作说明
      uploadFileData: {
        attachmentType: 11,
      },
      defaultFileList: [],
      action:
        globalConfig.rootUrl +
        '/api/pcWeb/accountExpenseApplication/uploadFile',
      // action:
      //   'https://beta.khsdb.com:444/api/pcWeb/accountExpenseApplication/uploadFile',
      addAttachmentId: [],
      delAttachmentId: [],
      fileList: [],
      locale: {
        emptyText: () => (
          <a-empty>
            <div style="padding:10px 0" slot="description">
              {' '}
              暂无数据{' '}
            </div>
          </a-empty>
        ),
      }, //空数据默认显示
    }
  },
  created() {
    console.log('globalConfig', globalConfig.rootUrl)
    this.is = this.$route.query.is
    this.expenseId = this.$route.query.expenseId
    this.queryParam = this.$route.query.record || {}
    if (this.queryParam.enclosure) {
      this.defaultFileList = this.queryParam.enclosure.map((i) => {
        return {
          uid: i.comAttachmentId,
          name: i.fileName,
          status: 'done',
          response: '',
          url: i.comAttachmentId,
        }
      })
      this.fileList = this.defaultFileList
    }
    if (this.queryParam.amount) {
      this.queryParam.amount = this.queryParam.amount
    }
    if (this.$route.query.is == 'check') {
      this.getDetail(this.$route.query.expenseId)
    } else {
      this.getExpenseList()
    }
  },
  methods: {
    preview(file) {
      if (file.response.data) {
        this.download(file.response.data.comAttachment.id)
      } else {
        this.download(file.uid)
      }
    },
    upload(file, fileList) {
      let fileList1 = [...file.fileList]
      fileList1 = fileList1.slice(-2)
      fileList1 = fileList1.map((item) => {
        if (item.response) {
          item.url = item.response.url
        }
        return item
      })
      this.fileList = fileList1
      if (file.file.status == 'done' && file.file.response) {
        this.addAttachmentId.push(file.file.response.data.comAttachment.id)
      }
    },
    handleRemove(file) {
      this.delAttachmentId.push(file.uid)
      const index = this.defaultFileList.indexOf(file)
      const newFileList = this.defaultFileList.slice()
      newFileList.splice(index, 1)
      this.defaultFileList = newFileList
    },

    download(id) {
      finOrder.getFile(id)
    },
    //获取详情
    getDetail(id) {
      finOrder.expenseDetails({ expenseId: id }).then((res) => {
        this.detail = res.data
      })
    },
    //获取费用管理列表
    getExpenseList() {
      finOrder.expenseApplication().then((res) => {
        this.termList = res.teaTerms.filter((item) => item.id != 0)
        this.expenseType = res.expenseType
      })
    },
    //返回
    back() {
      this.queryParam = {}
      this.is = '' //页面属性
      this.expenseId = '' //查看详情id
      this.detail = {} //详情内容
      this.operationDesc = '' //操作说明
      this.$router.push({ name: 'expenseMangement' })
    },
    //保存
    save(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          // if (!this.fileList.length) {
          //   this.$message.error('请上传附件')
          //   return
          // }
          finOrder
            .saveOrUpdate({
              ...this.queryParam,
              amount: this.queryParam.amount.toString(),
              expenseId: this.queryParam.id || null,
              addAttachmentId: this.addAttachmentId,
              delAttachmentId: this.delAttachmentId,
            })
            .then((res) => {
              this.$message.success('保存成功')
              this.$router.push({ name: 'expenseMangement' })
              this.$parent.getExpenseList()
            })
        }
      })
    },
    resubmit() {
      this.getExpenseList()
      this.queryParam = this.detail
      this.queryParam.amount = this.detail.amount
      if (this.queryParam.enclosure) {
        this.defaultFileList = this.queryParam.enclosure.map((i) => {
          this.addAttachmentId.push(i.comAttachmentId)
          return {
            uid: i.comAttachmentId,
            name: i.fileName,
            status: 'done',
            response: '',
            url: i.comAttachmentId,
          }
        })
        this.fileList = this.defaultFileList
      }
      if (this.detail.status == 3) {
        this.is = 'add'
        delete this.queryParam.id
      } else {
        this.is = 'update'
        this.detail.status = ''
      }
    },
    //删除按钮
    batchDelete() {
      let b = []
      b.push(this.detail.id)
      let self = this
      this.$confirm({
        title: '确定要删除吗?',
        okText: '确定',
        cancelText: '取消',
        content: '删除后，无法撤销',
        onOk() {
          finOrder.deleteExpenseRequest({ ids: b }).then((res) => {
            self.$message.success('操作成功')
            self.$router.push('expenseMangement')
            self.$parent.getExpenseList()
          })
        },
      })
    },
    //待提交状态提交申请
    batchSubmit() {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          // if (!this.fileList.length) {
          //   this.$message.error('请上传附件')
          //   return
          // }

          this.visible = true
        }
      })
    },
    //新建修改按钮提交申请
    submitApplication(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          // if (!this.fileList.length) {
          //   this.$message.error('请上传附件')
          //   return
          // }

          this.visible = true
        }
      })
    },
    //批量提交弹框按钮
    handleOk() {
      this.confirmLoading = true
      if (this.detail.status == -1) {
        let a = []
        a.push(this.detail.id)
        finOrder
          .batchSubmitRequest({
            ids: a,
            operationDesc: this.operationDesc,
            addAttachmentId: this.addAttachmentId,
            delAttachmentId: this.delAttachmentId,
          })
          .then((res) => {
            this.visible = false
            this.confirmLoading = false
            this.$message.success('操作成功')
            this.operationDesc = ''
            this.$router.push('expenseMangement')
            this.$parent.getExpenseList()
          })
      } else {
        finOrder
          .saveAndSubmit({
            ...this.queryParam,
            amount: this.queryParam.amount.toString(),
            operationDesc: this.operationDesc,
            addAttachmentId: this.addAttachmentId,
            delAttachmentId: this.delAttachmentId,
          })
          .then((res) => {
            console.log('res', res)
            this.visible = false
            this.confirmLoading = false
            this.$message.success('操作成功')
            this.operationDesc = ''
            this.$router.push('expenseMangement')
            this.$parent.getExpenseList()
          })
      }
    },
    handleCancel() {
      this.visible = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'src/config/var';
.mt20 {
  margin-top: 20px;
}
.mr15 {
  margin-right: 15px;
}
.w90 {
  width: 90px;
}
.btn {
  margin-left: 50px;
}
.detail {
  margin-left: 30px;
  margin-top: 20px;
  .tableWidth {
    width: 800px;
    margin: 20px 0;
  }
  .blod {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 10px;
  }
}
/deep/ .ant-form-item-label {
  margin-right: 20px;
}
/deep/ .ant-form-item {
  margin-bottom: 0px;
}
/deep/ .ant-form-item-control {
  line-height: 30px;
}
/deep/ .ant-form-item-label {
  line-height: 30px;
}
/deep/ .ant-form-item {
  margin-bottom: 10px;
}
</style>
